import { render, staticRenderFns } from "./addtorcomponents.vue?vue&type=template&id=6799eff5"
import script from "./addtorcomponents.vue?vue&type=script&lang=js"
export * from "./addtorcomponents.vue?vue&type=script&lang=js"
import style0 from "./addtorcomponents.vue?vue&type=style&index=0&id=6799eff5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports